export { default } from './ThreeCardsWithImage'
